import { FC, ReactNode } from "react";
import SuccessIcon from "shared/icons/status-icons/success-icon.svg?react";
import { cx } from "../../../../utils/classnames";
import FailIcon from "shared/icons/status-icons/fail-icon.svg?react";

interface Props {
  checked?: boolean;
  label?: ReactNode;
  labelClassName?: string;
  wrapperClassName?: string;
}

export const CheckComponent: FC<Props> = ({
  checked,
  label,
  labelClassName,
  wrapperClassName
}) => {
  return (
    <div className={cx("flex items-center gap-3", wrapperClassName)}>
      {checked === undefined ? (
        <div className="border-2 border-alpha-100 size-5 rounded-full" />
      ) : checked ? (
        <SuccessIcon className="w-5 h-5 text-primary-500" />
      ) : (
        <FailIcon className="w-5 h-5 text-content-100" />
      )}
      {label ? (
        <span
          className={cx(
            "truncate text-sm font-medium transition-all text-content-700",
            labelClassName
          )}
        >
          {label}
        </span>
      ) : null}
    </div>
  );
};
